export const getSid = (s) => s?.id ?? s?.pipeline_stage_id;

/** Sort by `ordering` ASC, then `id` ASC (matches GET /crm/pipeline/stages). */
export const sortStagesByOrdering = (stageList) => {
    if (!Array.isArray(stageList)) return [];
    return [...stageList].sort((a, b) => {
        const oa = a.ordering ?? Number.MAX_SAFE_INTEGER;
        const ob = b.ordering ?? Number.MAX_SAFE_INTEGER;
        if (oa !== ob) return oa - ob;
        return (getSid(a) ?? 0) - (getSid(b) ?? 0);
    });
};

/** Default ordering for a new stage: one past the current max, or 0 if none. */
export const getDefaultStageOrdering = (stageList) => {
    const sorted = sortStagesByOrdering(stageList);
    if (!sorted.length) return 0;
    const max = Math.max(...sorted.map((s, i) => (s.ordering != null ? Number(s.ordering) : i)));
    return max + 1;
};

export const parseStageOrdering = (value) => {
    const n = parseInt(String(value).trim(), 10);
    if (Number.isNaN(n) || n < 0) return null;
    return n;
};
